export enum Sizes {
	Hero = "hero",
	SecondaryHero = "secondaryHero",
	Section = "section",
	SecondarySection = "secondarySection",
	Card = "card",
}

export type Size = (typeof Sizes)[keyof typeof Sizes];

export const titleStyles: Record<Size, string> = {
	hero: "text-6xl/[0.9] sm:text-8xl/[0.8] md:text-9xl/[0.8]",
	secondaryHero: "text-5xl sm:text-6xl/[0.9] md:text-7xl/[0.9]",
	section: "text-4xl sm:text-5xl/[0.9] md:text-6xl/[0.9]",
	secondarySection: "text-3xl sm:text-4xl/[0.9] md:text-5xl/[0.9]",
	card: "text-base/[0.9] sm:text-lg/[0.8] md:text-xl/[0.8]",
};

export const textStyles: Record<Size, string> = {
	hero: "mt-6 text-xl/7 sm:text-2xl/8 text-gray-950/80",
	secondaryHero: "mt-5 text-lg/7 sm:text-xl/8 text-gray-950/80",
	section: "mt-4 text-base/6 sm:text-lg/7 text-gray-800/80",
	secondarySection: "mt-3 text-sm/5 sm:text-base/6 text-gray-800/80",
	card: "mt-3 text-sm/5 sm:text-base/6 text-gray-700/80",
};
